<app-breadcrumb [home]="home" [items]="breadcrumbs" />

<!-- Título e ação na mesma faixa, mas a ação NÃO vive dentro do `.page-header`: ele é
     `display: block` no estilo global e ocupa a largura toda, jogando o botão para debaixo
     do avatar fixo do shell. Mesmo cuidado do "Meus Deals". -->
<header class="page-header">
  <h2>Usuários</h2>
</header>

<!--
  Usuário interno chegou aqui por URL direta: o `PermissionGuard` só olha a permissão, e o
  grupo FULL do TENANT recolhe `COMMERCIAL_MANAGE_USERS` sozinho no startup. A tela não tem o
  que mostrar — o parceiro sai do token, e ele não tem — então diz isso e aponta para onde a
  Legatus faz essa tarefa, em vez de exibir uma lista vazia e um botão que sempre falha.
-->
@if (!ehParceiro()) {
  <div class="partner-users__nota" role="note">
    <i class="pi pi-info-circle" aria-hidden="true"></i>
    <div>
      <strong>Esta tela é do parceiro.</strong>
      <p>
        Ela mostra a equipe do parceiro de quem está logado, e o seu usuário é interno da Legatus.
        Para cadastrar ou editar um usuário de parceiro, use
        <a routerLink="/dashboard/user/register">Gerenciamento › Usuários</a>, escolhendo o tipo
        <em>Parceiro</em> e o parceiro no próprio cadastro.
      </p>
    </div>
  </div>
} @else {
  <div class="partner-users__toolbar">
    <div class="partner-users__toolbar-info">
      <p class="partner-users__count">
        {{ usuarios().length }}
        {{ usuarios().length === 1 ? 'usuário na sua equipe' : 'usuários na sua equipe' }}
      </p>
      <!--
        O recorte de deals depende do PERFIL desde 18/09/2026. Até então a frase dizia "cada um
        vê apenas os deals que ele mesmo registrar", o que passou a ser falso para o master da
        equipe — e é a única explicação que a tela dá sobre o que a coluna Perfil significa.
      -->
      <p class="partner-users__hint">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        Todos enxergam as mesmas empresas que você. Quem é <strong>Comum</strong> vê apenas os deals
        que ele mesmo registrar; quem é <strong>Master</strong> vê os de toda a equipe e administra
        esta tela.
      </p>
    </div>

    <div class="partner-users__toolbar-actions">
      <app-button
        label="Cadastrar usuário"
        icon="pi pi-user-plus"
        [type]="'button'"
        (sendButtonClick)="abrirCadastro()" />
    </div>
  </div>

  @if (loading()) {
    <app-loading />
  } @else {
    <!-- `dataKey` fica no padrão `'id'` de propósito: `PartnerUserResponse` TEM `id`. Foi a
       ausência dele em `PartnerCompanyResponse` que causou o bug de "marcar um seleciona
       todos" na aba Empresas — aqui não há checkbox, mas o padrão está correto de todo modo. -->
    <app-table
      [items]="usuarios()"
      [columnDefinitions]="columnDefinitions"
      [hasPagination]="true"
      [inMemoryPagination]="true"
      [rows]="15"
      [rowsPerPageOptions]="[15, 30, 50, 100]"
      [getOptionsFunction]="acoesDaLinha.bind(this)">
      <!-- Perfil: o master aparece marcado, e é o que explica a linha sem menu de ação. -->
      <ng-template appNamedTemplate="perfil" let-item>
        <span class="partner-user-tag" [class.partner-user-tag--master]="item.isMaster">
          {{ item.isMaster ? 'Master' : 'Comum' }}
        </span>
      </ng-template>

      <ng-template appNamedTemplate="acesso" let-item>
        <span class="partner-user-tag" [class.partner-user-tag--pending]="!item.hasPassword">
          {{ item.hasPassword ? 'Senha criada' : 'Convite pendente' }}
        </span>
      </ng-template>

      <!-- Situação como pill, não texto solto: é o estado que o master procura ao varrer a
         lista, e cor resolve isso antes da leitura. -->
      <ng-template appNamedTemplate="situacao" let-item>
        <span class="partner-user-tag" [class.partner-user-tag--inactive]="!item.active">
          {{ item.active ? 'Ativo' : 'Inativo' }}
        </span>
      </ng-template>
    </app-table>

    @if (!usuarios().length) {
      <p class="partner-users__empty">
        Você ainda não tem ninguém na equipe. Cadastre um usuário e ele recebe por e-mail um link
        para criar a senha de acesso.
      </p>
    }
  }

  <app-modal-partner-user #modalUsuario (salvou)="carregar()" />
}
